export default "__VITE_ASSET__DYnaCNsl__"